export enum EDays {
    Saturday = 6,
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5
}

export enum PersianDayEnum {
    'شنبه' = 6,
    'یک‌شنبه' = 0,
    'دوشنبه' = 1,
    'سه‌شنبه' = 2,
    'چهارشنبه' = 3,
    'پنج‌شنبه' = 45,
    'جمعه' = 5,
}